/**
 * Created by comoon on 1/28/16.
 */

var {Dispatcher} = require('flux');

module.exports = new Dispatcher();


/** WEBPACK FOOTER **
 ** ./script/Dispatcher.js
 **/